// 02.9-shared-widgets.md paso b (§5) -- extraido de InlineSocialOutline.jsx, sin cambios.
const DropdownOptions = ({ options, onSelect, style }) => (
    <div className="iso-dropdown" style={style}>
        {options.map(opt => (
            <div key={opt} className="iso-dropdown-item" onClick={() => onSelect(opt)}>
                {opt}
            </div>
        ))}
    </div>
);

export default DropdownOptions;
